import React from 'react'

class Form extends React.Component {

  render() {

    console.log(this.refs)

    return(
      <form>
      {
        this.props.children
      }  
      </form>
    )

  }

}

export default Form


// WEBPACK FOOTER //
// ./src/components/Form/Form.js